<!------------------------------------------- template ------------------------------------------->
<template>
  <div :class="{page:bgColorBlue}" class="pageWhite">
    <div class="wholesale_programme_title">
      <div class="wholesale_programme_title_text" style="width: 128px">
        成功案例
        <img src="../../assets/img/title3@2x.png" alt=""/>
      </div>
      <div class="zhexian"></div>
    </div>
    <div class="menu-ul">
      <div class="swiper-button-prev" slot="button-prev">
        <div class="prev_btn">
          <i class="el-icon-arrow-left"></i>
        </div>
      </div>
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <div class="case_swiper_box">
            <img src="../../assets/img/ningbo.png" alt="">
            <div class="case_title">宁波农副产品物流中心</div>
            <div class="case_content">
              项目介绍，项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="case_swiper_box">
            <img src="../../assets/img/ningbo.png" alt="">
            <div class="case_title">宁波农副产品物流中心</div>
            <div class="case_content">
              项目介绍，项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="case_swiper_box">
            <img src="../../assets/img/ningbo.png" alt="">
            <div class="case_title">宁波农副产品物流中心</div>
            <div class="case_content">
              项目介绍，项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="case_swiper_box">
            <img src="../../assets/img/ningbo.png" alt="">
            <div class="case_title">宁波农副产品物流中心</div>
            <div class="case_content">
              项目介绍，项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="case_swiper_box">
            <img src="../../assets/img/ningbo.png" alt="">
            <div class="case_title">宁波农副产品物流中心</div>
            <div class="case_content">
              项目介绍，项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容项目介绍内容
            </div>
          </div>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="swiper-button-next" slot="button-next">
        <div class="prev_btn">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<!-------------------------------------------- script -------------------------------------------->
<script>
import {swiper, swiperSlide} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: '',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    bgColorBlue: {
      type: Boolean,
    },
  },

  data() {
    return {
      // swiperOption: {
      //   loop: false,
      //   autoplay: {
      //     delay: 3000,
      //     stopOnLastSlide: false,
      //     disableOnInteraction: false
      //   },
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true
      //   }
      // },
      swiperOption: {
        autoplay:true,
        slidesPerView: 3, //设置slider容器能够同时显示的slides数量
        speed: 500, //滑动速度
        spaceBetween: 34, //slide之间的距离（单位px
        slidesPerGroup: 3, //定义slides的数量多少为一组
        centeredSlides: false, //设定为true时，活动块会居中，而不是默认状态下的居左
        loop: true, //会在原本slide前后复制若干个slide(默认一个)并在合适的时候切换，让Swiper看起来是循环的
        loopFillGroupWithBlank: true, //不到6个的组，剩下的slice会用空白填满
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        allowTouchMove: false, //禁止手动拖动滑动
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        preventLinksPropagation: false, //拖动Swiper时阻止click事件,如果没有禁止拖动需要设置此项
      },
    }
  },

  /* 一.生命周期函数 */
  created() {
  },

  /* 二.监控函数 */
  watch: {},

  computed: {},

  /* 三.内部功能函数 */
  methods: {
    /* ----------------------事件调用函数------------------------ */
    // 事件调用函数注释
    handleXxx() {
    },

    /* ----------------------内部调用函数------------------------ */
    // 内部功能函数注释
    doSomething() {
    },

    /* ----------------------服务请求函数------------------------ */
    // 服务请求函数注释
    ajax_getXxx() {
    }
  }
}
</script>

<!--------------------------------------------- style -------------------------------------------->
<style scoped>
.pageWhite {
  background: #fff;
  padding-top: 1px;
  padding-bottom: 1px;
  box-sizing: border-box;
}

.page {
  background: #F7FBFF;
  padding-top: 1px;
  padding-bottom: 1px;
  box-sizing: border-box;
}

/* 覆盖按钮本身样式，使用img是为了兼容ie，swipe本身的按钮样式是在after里设置的font-family*/
.prev_btn {
  width: 72px;
  height: 130px;
  line-height: 130px;
  text-align: center;
  background: #DFEAFD;
  font-size: 48px;
  color: #FFFFFF;
}

.case_swiper_box {
  width: 376px;
  height: 400px;
  background: #FFFFFF;
  box-shadow: 0px 2px 15px 5px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  padding: 28px 28px 0;
}

.case_swiper_box img {
  width: 320px;
  height: 180px;
}

.case_title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin: 16px auto 14px;
}

.case_content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  text-align: left;
}

>>> .swiper-button-prev {
  position: relative;
  margin: 16px 0 9px 0;
  color: rgb(101, 101, 101);
  top: -50px;
  left: -104px;
  right: 0;
  background-image: none;
}

>>> .swiper-button-next {
  position: relative;
  margin: 16px 0 9px 0;
  color: rgb(101, 101, 101);
  top: -50px;
  left: 62px;
  right: 0;
  background-image: none;
}

>>> .swiper-button-prev:after {
  content: none;
}

>>> .swiper-button-next:after {
  content: none;
}

.menu-ul {
  /*width: 1444px;*/
  width: 1290px;
  /*width: calc(100% - 476px);*/
  display: flex;
  align-items: center;
  height: 400px;
  margin: 50px auto 48px;
}

.menu-list {
  width: 1128px;
  display: flex;
  align-items: center;
  height: 62px;
  background: #FFFFFF;
  font-size: 16px;
  color: #666666;
}

>>> .swiper-slide {
  /*width: 100% !important;*/
  width: 376px !important;
}

.swiper-slide span {
  display: block;
  padding: 16px 0 9px 0;
  height: 62px;
}

>>> .swiper-container {
  /*overflow: unset;*/
  padding: 20px;
}

.wholesale_programme_title {
  width: 1200px;
  margin: 0 auto;
}

.wholesale_programme_title_text {
  width: 240px;
  text-align: center;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin: 73px auto 0;
  z-index: 99;
}

.wholesale_programme_title_text img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -13px;
  z-index: -1;
}

.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}
</style>
